'use strict';

var React = require('react');

var SvgLiveViewMajor = function SvgLiveViewMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13.293 2.707a1 1 0 0 0 1.707-.707v-1a1 1 0 0 0-2 0v1a1 1 0 0 0 .293.707zm3.707 1.293a.999.999 0 0 1-.707-1.707l1-1a1 1 0 1 1 1.414 1.414l-1 1a.996.996 0 0 1-.707.293zm2 3h-1a1 1 0 1 1 0-2h1a1 1 0 1 1 0 2zm-4-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-14-3a2 2 0 0 1 2-2h8v2h-8v8.464c1.795-.934 4.836-1.464 7-1.464 2.164 0 5.205.529 7 1.464v-2.464h2v8a2 2 0 0 1-2 2h-14a2 2 0 0 1-2-2v-14z"
  }));
};

exports.SvgLiveViewMajor = SvgLiveViewMajor;
